import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
import config from './config';
import { Provider } from 'react-redux';
import { onError } from '@apollo/client/link/error';
import { setContext } from '@apollo/client/link/context';
import {
  ApolloProvider,
  ApolloClient,
  InMemoryCache,
  HttpLink,
  ApolloLink,
} from '@apollo/client';
import configureStore from './store/store';
import 'semantic-ui-css/semantic.min.css';

import { usuarioLogueado } from './utils/loggedInfo';
import { parseJwt } from './utils/parseJwt';
import CustomLoader from './components/common/CustomLoader';

const logout = () => {
  localStorage.removeItem('usuarioLogueado');
  localStorage.removeItem('DASA_AUTH_JWT_ID');
};

const store = configureStore();

const httpLink = new HttpLink({ uri: config.apiUrl.concat('graphql') });

const authLink = setContext((_, { headers }) => {
  // get the authentication token from local storage if it exists
  const { idToken, accessToken } = usuarioLogueado() || {};
  const token = idToken || accessToken || null;

  // check if your session has already expired
  if (idToken) {
    try {
      const { exp } = parseJwt(idToken);
      const timeNow = Math.round(Date.now() / 1000);
      if (exp && timeNow >= exp) { logout(); window.location.reload(); }
    } catch {}
  }
  // return the headers to the context so httpLink can read them
  return {
    headers: {
      ...headers,
      Authorization: token ? `Bearer ${token}` : '',
    },
  };
});

const errorLink = onError(({ graphQLErrors, networkError }) => {
  if (networkError.statusCode === 401) {
    console.log(graphQLErrors);
    logout();
  }
});

const link = ApolloLink.from([errorLink, httpLink]);

const client = new ApolloClient({
  link: authLink.concat(link),
  cache: new InMemoryCache(),
  defaultOptions: { watchQuery: { fetchPolicy: 'cache-and-network' } },
});

ReactDOM.render(
  <ApolloProvider client={client}>
    <Provider store={store}>
      <Suspense fallback={<CustomLoader />}>
        <App />
      </Suspense>
    </Provider>
  </ApolloProvider>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
